@if (progressLabelPosition() === 'left') {
  <div class="flex gap-2 items-center justify-start">
    @if (label()) {
      <div class="flex" [style.minWidth]="labelMinWidth() + 'px'">
        <span class="font-bold min-w-12">{{ label() }}</span>
      </div>
    }

    @if (isProgressLabelVisible()) {
      <div class="flex" [style.minWidth]="progressLabelMinWidth() + 'px'">
        <span>
          @if (isValuePercentage()) {
            {{ current() | percentage }}
          } @else {
            {{ current() | numberSuffix }}{{ progressSuffix() }}
          }
        </span>
        <span [style.opacity]="progressLabelTotalOpacity()" [style.color]="progressLabelTotalColor()">
          /
          @if (isValuePercentage()) {
            {{ total() | percentage }}{{ progressSuffix() }}
          } @else {
            {{ calculatedTotal() | numberSuffix }}{{ progressSuffix() }}
          }
          {{ progressCurrency() }}
        </span>
      </div>
    }

    <div #progressHost>
      <ng-container *ngTemplateOutlet="progressBar" />
    </div>
  </div>
}

@if (progressLabelPosition() === 'top') {
  <div class="flex flex-col gap-2">
    @if (isProgressLabelVisible()) {
      <div class="flex min-w-12 items-center gap-1">
        <span class="font-bold text-[28px]">
          @if (isValuePercentage()) {
            {{ progressPrefix() }}{{ current() | percentage }}
          } @else {
            {{ progressPrefix() }}{{ current() | numberSuffix }}{{ progressSuffix() }}
          }
        </span>
        <span [style.opacity]="progressLabelTotalOpacity()" [style.color]="progressLabelTotalColor()">
          <div class="flex items-center gap-1">
            <span>/</span>
            <span>
              @if (isValuePercentage()) {
                {{ progressPrefix() }}{{ total() | percentage }}{{ progressSuffix() }}
              } @else {
                {{ progressPrefix() }}{{ calculatedTotal() | numberSuffix }}{{ progressSuffix() }}
              }
              {{ progressCurrency() }}
            </span>
          </div>
        </span>
      </div>
    }

    <div #progressHost>
      <ng-container *ngTemplateOutlet="progressBar" />
    </div>
  </div>
}

@if (progressLabelPosition() === 'right') {
  <div class="flex gap-2 items-center justify-end">
    <div #progressHost>
      <ng-container *ngTemplateOutlet="progressBar" />
    </div>

    @if (label()) {
      <div class="flex" [style.minWidth]="labelMinWidth() + 'px'">
        <span class="font-bold min-w-12">{{ label() }}</span>
      </div>
    }

    @if (isProgressLabelVisible()) {
      @if (isProgressLabelPercentage()) {
        <div class="flex" [style.minWidth.px]="progressLabelMinWidth()">
          <span
            [style.fontSize.px]="progressLabelFontSize()"
            [style.fontWeight]="progressLabelFontWeight()"
            [matTooltip]="
              total() === null
                ? ('pages.campaignDetails.overview.noTargetSet' | translate)
                : ('pages.campaignDetails.overview.currentProgress' | translate)
            "
          >
            @if (total() === null) {
              {{ 'shared.na' | translate }}
            } @else {
              {{ progress() | percentage: false : progressLabelDecimalPlaces() }}{{ progressSuffix() }}
            }
          </span>
        </div>
      } @else {
        <div class="flex" [style.fontSize.px]="progressLabelFontSize()" [style.minWidth.px]="progressLabelMinWidth()">
          <span>
            @if (isValuePercentage()) {
              {{ current() | percentage }}
            } @else {
              {{ current() | numberSuffix }}{{ progressSuffix() }}
            }
          </span>
          /
          <span
            class="self-center"
            [style.fontSize.px]="progressLabelTotalFontSize()"
            [style.opacity]="progressLabelTotalOpacity()"
            [style.color]="progressLabelTotalColor()"
          >
            @if (isValuePercentage()) {
              {{ total() | percentage }}{{ progressSuffix() }}
            } @else {
              {{ calculatedTotal() | numberSuffix }}{{ progressSuffix() }}
            }
            {{ progressCurrency() }}
          </span>
        </div>
      }
    }
  </div>
}

<ng-template #progressBar>
  <mat-progress-bar
    mode="determinate"
    class="custom-progress-bar"
    [matTooltip]="tooltipContent()"
    [value]="displayValue()"
    [style.minWidth]="minWidth() + 'px'"
    [style.height]="height() + 'px'"
    [style.width]="width() + 'px'"
    [style.boxShadow]="borderColor() ? '0 0 0 0.3px ' + borderColor() : 'none'"
    [style.--progress-current-color]="currentColor()"
    [style.--progress-total-color]="totalColor()"
    [style.--progress-height]="height() + 'px'"
    [style.--progress-width]="width() + 'px'"
    [style.--progress]="displayValue()"
    [style.--progress-multiplier]="progressMultiplier() + 'px'"
  />
</ng-template>
